import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { MoveList } from 'chessboard/model/move-list/types';
import { CONTEXT_MENU_ACTION_NAMES } from '../config/context-menu-action-names';

/**
 * Create DeleteVariation action
 */
export function createDeleteComment(store: Store, _storeActions: StoreActions): ContextMenu.Action {
  return {
    getDisplayName: ({ node }) => {
      if (node.ids.move > 0) {
        return MoveList.Translation.Actions.DeleteComment;
      } else {
        return MoveList.Translation.Actions.DeleteCommentAfter;
      }
    },

    action: CONTEXT_MENU_ACTION_NAMES.DeleteCommentAfter,
    isVisible,
    handler,
  };

  /**
   * visible only when comment is present
   */
  function isVisible({ node }: ContextMenu.ActionHandlerContext) {
    const isEditable = store.commentsEditable.get();

    return node.comment !== undefined && isEditable;
  }

  /**
   * handler to delete comment after node
   */
  function handler({ node, game }: ContextMenu.ActionHandlerContext): void {
    game.updateNode(node.ids, { comment: undefined });
  }
}
